/** @module CollectionBook/MassCopyMCProductsForm */
define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare,Widget) {

	return declare(Widget,{

		/**
		* Modified the form view
		*/
		_resolveView: function() {
			this.addFixedValue("ToCollection", this.urlRoot);
			this.inherited(arguments);
		}
	});
});
